



































import {filterMatchColumns} from '@/helpers';
import {tournamentsApi} from '@/api/TournamentsApi';
import {HeroesVersion} from '@/api/HeroesVersion';
import {reportsService} from '@/services/ReportsService';
import {
  of,
  combineLatest,
  from,
  asyncScheduler,
  } from 'rxjs';
import {map, switchMap, filter} from 'rxjs/operators';
import {Component, Prop, Vue} from 'vue-property-decorator';
import BlankLoader from '../../components/common/BlankLoader.vue';
import UserLinks from '../../components/common/UserLinks.vue';
import QuickAccess from '../../components/rating/QuickAccess.vue';
import RandomSign from '../../components/common/RandomSign.vue';
import DataFilter from '../../components/common/DataFilter.vue';
import DataTable from '../../components/common/DataTable.vue';
import CollapsibleTable from '../../components/common/CollapsibleTable.vue';
import UnconfirmedReports from '../../components/rating/UnconfirmedReports.vue';
import {
  generateLangSubscriptions,
  observeProp,
  observeRouteParam,
  watchAsLoadedObservable,
} from '@/components/observe';
import {Route} from 'vue-router';

@Component<UnconfirmedReportsView>({
  components: {
    UnconfirmedReports,
    BlankLoader,
    UserLinks,
    QuickAccess,
    RandomSign,
    DataFilter,
    DataTable,
    CollapsibleTable,
  },
  subscriptions() {
    const $route$ = observeProp<Route>(this, '$route');
    const lang$ = observeRouteParam<string>($route$, 'lang');
    const showViolators$ = observeProp<boolean>(this, 'showViolators');
    const username$ = observeProp<string>(this, 'username');
    const userInfo$ = from(tournamentsApi.getCurrentTournamentUserInfo$(), asyncScheduler);
    const unconfirmedReports$ = lang$.pipe(
      switchMap((lang) => from(reportsService.getUnconfirmedReports(HeroesVersion.Heroes3, lang), asyncScheduler)),
    );

    return Object.assign(generateLangSubscriptions(lang$), {
      title: combineLatest(
        observeProp(this, 'translate'),
        username$,
      ).pipe(
        filter(([translate]) => !!translate),
        switchMap(([translate, username]: any) => of(!!username
          ? `${translate.unconfirmed_reports} (${username})`
          : translate.unconfirmed_reports)),
      ),
      currentUsername: username$,
      currentShowViolators: showViolators$,
      userInfo: userInfo$,
      unconfirmedReports: combineLatest(
        unconfirmedReports$,
        showViolators$,
        username$,
        userInfo$,
      ).pipe(
        switchMap(([reports, showViolators, username]: any) => of([
          reports.filter((x: any) => this.filterMatch(x, username)),
          showViolators,
        ])),
        map(([reports, showViolators]) => showViolators ? reports.filter((x: any) => x.has_violator) : reports),
      ),
      hasReports: observeProp(this, 'unconfirmedReports').pipe(
        switchMap((x: any) => of(!!x && x.length > 0)),
      ),
      noReports: observeProp(this, 'unconfirmedReports').pipe(
        switchMap((x: any) => of(!!x && x.length === 0)),
      ),
      isUnconfirmedReportsLoaded: watchAsLoadedObservable(this, 'unconfirmedReports'),
    });
  },
})
export default class UnconfirmedReportsView extends Vue {
  @Prop() public showViolators!: boolean;
  @Prop() public username!: string;

  public filterMatch(report: any, username: any) {
    const columns = [
      'player1_username',
      'player2_username',
    ];
    return username && username.length
      ? filterMatchColumns(report, username, columns)
      : true;
  }

}
